import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import { getAppContext, loadAction } from '../../util/decorators';
import loadDataSources from '../../action/loadDataSources';
import linkTag2Initializer from '../../util/linkTag2Initializer';
import PageHeading from '../PageHeading.jsx';
import MediaListContainer from './MediaListContainer.jsx';
import blogConfig from '../../config/blogConfig.json';
import BlogMeta from './BlogMeta';

const mapStateToProps = state => ({
  country: state.country,
});

const $loadAction = loadAction(
  (args) => loadDataSources({dataSourceConfigs: {recentBlogPosts: `${args.country}.recentBlogPosts`}, ...args})
);

const BlogList = props =>
  <PageWithSidebars>
    <BlogMeta />
    <PageHeading firstPart={props.app.t('BlogIndex.heading1')} secondPart={props.app.t('BlogIndex.heading2')} />
    <MediaListContainer mediaType="blogs"
                        metaInfo={blogConfig[props.country]}
                        dataSource="recentBlogPosts"
                        linkTemplate="BlogPage"
                        showMoreText={props.app.t('BlogIndex.show_more')} />
  </PageWithSidebars>;

BlogList.propTypes = {
  app: React.PropTypes.object.isRequired,
  country: React.PropTypes.string.isRequired,
};

export default compose(
  connect(mapStateToProps),
  $loadAction,
  linkTag2Initializer('blogs'),
  getAppContext
)(BlogList);



// WEBPACK FOOTER //
// ./src/component/MediaPages/BlogList.jsx